import firebase from "firebase/app";
import AuthModel from "@/models/auth";

export const LOCAL_STORAGE_KEY = "olv_admin_auth";

export default class AuthController {
  public static watchLoggedInState(callback: Function) {
    const callbackLoggedIn = (user: firebase.User) => {
      AuthController.setIsAuth();
      callback(user);
    };

    const callbackNotLoggedIn = () => {
      AuthController.clearAuth();
      callback(null);
    };

    AuthModel.watchLoginState(callbackLoggedIn, callbackNotLoggedIn);
  }

  public static isAuth(): boolean {
    return !!localStorage.getItem(LOCAL_STORAGE_KEY);
  }

  public static setIsAuth() {
    localStorage.setItem(LOCAL_STORAGE_KEY, "true");
  }

  public static clearAuth() {
    localStorage.removeItem(LOCAL_STORAGE_KEY);
  }

  public static login(email: string, password: string) {
    return AuthModel.login(email, password);
  }

  public static logout() {
    return AuthModel.logout();
  }

  public static changePassword(newPassword: string) {
    return AuthModel.changePassword(newPassword);
  }
}
